import { Component } from '@angular/core';

@Component({
  selector: 'hfc-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss']
})
export class StickyFooterComponent {}
